import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AdmissionForm from "../components/AdmissionForm";
import PaymentDetails from "../components/PaymentDetails";
import SeasonNotice from "../components/SeasonNotice";
import { useSeason } from "../season";

function App() {
  const { season, error } = useSeason();

  return (
    <div className="flex flex-col min-h-screen">
      <Header season={season} />
      <main className="flex-grow flex flex-col md:flex-row justify-center p-4 bg-slate-100 space-y-4 md:space-y-0 md:space-x-4">
        {!season && !error && (
          <div className="flex flex-col items-center justify-center p-12 text-gray-600">
            <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-3"></div>
            Loading the registration form…
          </div>
        )}
        {error && (
          <div className="w-full max-w-xl bg-white p-8 rounded shadow text-center text-red-700">{error}</div>
        )}
        {season && (
          <>
            {season.year && (
              <div className="w-full md:w-1/2 bg-white p-8 rounded shadow">
                <PaymentDetails season={season} />
              </div>
            )}
            <div className="w-full md:w-1/2 bg-white p-8 rounded shadow">
              {season.status === "open" ? <AdmissionForm season={season} /> : <SeasonNotice season={season} />}
            </div>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default App;
